<template>
  <div class="printManagementDialog">
    <el-dialog title="确认设计师" :visible.sync="dialogVisible" width="1300px">
      <div class="orderMessage" style="border: none">
        <el-table :data="tableData" :border="true" style="width: 100%" >
            <el-table-column
                label="序号"
                type="index"
                width="50"
                align="center">
            </el-table-column>
          <el-table-column prop="designer" label="设计师" align="center" >
            <template slot-scope="scope">
              <div class="designerImg">
                <!-- <img :src="scope.row.designIconUrl" alt="" /> -->

                  <p style="margin-right:10px">{{ scope.row.designName }}</p>
                  <!-- <i class="el-icon-message-solid"></i> -->
                  <i class="iconfont icon-weixin" style="font-size: 18px; cursor: pointer" @click="startChat(scope.row.designerUserId)"></i>

              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="报价时间" align="center" width="200">
          </el-table-column>
          <el-table-column prop="offer" label="报价金额" align="center">
          </el-table-column>
          <el-table-column prop="planDeliveryTime" label="计划工期" align="center">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="报价说明"
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="attachment" width="350" label="附件" align="center">
              <template slot-scope="scope">
                  <div v-for="(item,index) in scope.row.designerAttachmentForDemands"
                       style="color: #1890FF;cursor: pointer;margin-right: 20px;"
                       @click="downloadFile(item.fileUrl)"
                       :key="index">
                      {{ item.fileName }}
                  </div>
              </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-popconfirm
                title="您确定要选择该设计师吗？"
                @confirm="submit(scope.row)"
              >
                <el-button slot="reference" type="primary" size="small"
                  >选择</el-button
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

      <!--聊天窗口-->
      <chat-dialog ref="chatDialogRef"></chat-dialog>

  </div>
</template>

<script>
import {findDemandOfferList, getRongCloudUser, saveDemandOffer, saveDesignOrder} from '../../utils/interface';
import chatDialog from "../../components/chat/chatDialog";
export default {
  name: "demandDialog",
  data() {
    return {
      dialogVisible: false,
      tableData: [],
        info:"",
    };
  },
    components: {
      chatDialog
    },
  methods: {
    init(info) {
      this.info = info;
      this.dialogVisible = true;
        findDemandOfferList({uuid:info.uuid}).then((res)=>{
           if(res.success){
               this.tableData = res.data;
           }
        });
    },

    submit(item) {
        let params = {
            uuid:this.info.uuid,
            winner:item.designName,
            winnerUuid:item.designerUuid,
            planDeliveryTime:item.planDeliveryTime
        };
        saveDemandOffer(params).then((res)=>{
            if(res.success){
                this.$message.success('保存成功!');
                /*let orderParams = {
                    demandUuid:item.demandUuid,
                    demandName:item.demandName,
                    demandRemark:item.demandDes,
                    lowPreAmount:item.lowPreAmount,
                    highPreAmount:item.highPreAmount,
                    offerPrice:item.offer,
                    designerUuid:item.designerUserId,
                    designerName:item.designName,
                    offerNum:this.tableData.length,
                    deadLine:item.deadline,
                    planDeliveryTime:item.planDeliveryTime
                };
                saveDesignOrder(orderParams).then((res)=>{
                    if(res.success){
                        this.$message.success('保存成功!');
                        this.dialogVisible = false;
                        this.$emit('chooseOffser');
                    }else{
                        this.$message.error(res.message);
                        this.dialogVisible = false;
                        this.$emit('chooseOffser');
                    }
                });*/
            }else{
                this.$message.error(res.message);
            }
            this.dialogVisible = false;
            this.$emit('chooseOffser');
        });
    },
      downloadFile(fileUrl){
          let a = document.createElement('a');
          a.href = fileUrl;
          a.click();
      },
      startChat(targetUuid) {
          let user = this.$store.state.userMessages;
          getRongCloudUser(targetUuid).then(res=> {
              console.log(res);
              this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
          });
      }
  },
};
</script>

<style scoped lang="less">
// 订单信息
.orderMessage {
  border-bottom: 1px solid #efefef;
  margin: 0 24px;
  padding-bottom: 8px;
  .orderMessage_title {
    height: 64px;
    display: flex;
    align-items: center;
    h4 {
      font-size: 16px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      margin-right: 24px;
    }
    p {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      margin-right: 15px;
    }
    i {
      color: #1890ff;
      cursor: pointer;
    }
  }
  .orderMessage_con {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 16px;
    p {
      width: 362px;
    }
  }
  .designerImg {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      margin-right: 8px;
    }
    i {
      color: #1890ff;
    }
  }
  .orderRecordBox {
    border-bottom: 1px solid #efefef;
    .orderRecord {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .orderRecordL {
        display: flex;
        .orderRecordL_one {
          position: relative;

          i {
            display: inline-block;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: #1890ff;
            // margin-bottom: 18px;
          }
          p {
            width: 1px;
            height: 85%;
            background: #efefef;
            position: absolute;
            left: 50%;
            transform: translate(-50%, 2px);
          }
        }
        .orderRecordL_img {
          margin: 0 20px 0 15px;
          img {
            width: 96px;
            height: 96px;
          }
        }
        .orderRecordL_mess {
          font-size: 14px;
          h4 {
            margin: 0;
            font-size: 16px;
            margin-bottom: 5px;
          }
          p:nth-of-type(1) {
            margin-bottom: 32px;
          }
          p:nth-of-type(2) {
            margin-bottom: 16px;
          }
          p:nth-of-type(3) {
            margin-bottom: 11px;
          }
          span {
            color: #1890ff;
          }
        }
      }
      .orderRecordR {
        background: #fafafa;
        border-radius: 2px;
        padding: 12px 24px;
        font-size: 14px;
        width: 47%;
        h4 {
          margin: 0;
          font-weight: 500;
          margin-bottom: 5px;
        }
        p:nth-of-type(1) {
          margin-bottom: 35px;
        }
      }
    }
  }
  .orderRecordButton {
    margin-top: 24px;
    text-align: right;
    margin-bottom: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/demand/confirmDesigner.vue